
/*
VARIÁVEIS
--------------------------------------------*/

const topbar 			= $('#mainHeader');
const blocoBusca 		= topbar.find('.Busca');
const openBusca 		= topbar.find('.Busca .actions span.open');
const openHorarios 		= topbar.find('.Menu .horarios a.drodown');
const boxHorarios 		= topbar.find('.Menu .horarios');
const openMenu 			= topbar.find('.Menu .menuActions span.openMenu');
const closeMenu 		= topbar.find('.Menu .menuActions span.closeMenu');
const mainMenu 			= topbar.find('.Menu #navegacaoPrincipal');

const formBusca	 		= topbar.find('.Busca form');
const resetFormBusca	= topbar.find('.Busca form input[type="reset"]');

const formBuscaMobile		= topbar.find('.Menu #navegacaoPrincipal form');
const resetFormBuscaMobile	= topbar.find('.Menu #navegacaoPrincipal form input[type="reset"]');

/*
FUNÇÕES
-------------------------------------------- */

function openMainMenu()
{
	closeHorariosBox();
	closeBuscaForm();

	// console.log('Open Menu')

	$('.eapps-widget.eapps-instagram-feed-popup').css({'z-index' : 0 , 'height' : 0});
	$('#menuMobileClose').css({'display':'block'});

	if($(window).width() <= 1024)
	{
		$('body').css({'overflow':'hidden'});
	}
	
	openMenu.removeClass('Activated');
	closeMenu.addClass('Activated');

	mainMenu.addClass('opened');
}

function closeMainMenu()
{
	// console.log('Close Menu')

	$('.eapps-widget.eapps-instagram-feed-popup').css({'z-index' : 99999 , 'height' : 'auto'});
	$('#menuMobileClose').css({'display':'none'});

	if($(window).width() <= 1024)
	{
		$('body').css({'overflow':'auto'});
	}

	openMenu.addClass('Activated');
	closeMenu.removeClass('Activated');

	mainMenu.removeClass('opened');
}

function openHorariosBox()
{
	closeMainMenu();
	closeBuscaForm();

	openHorarios.removeClass('closed');
	boxHorarios.addClass('opened');
}

function closeHorariosBox()
{
	openHorarios.addClass('closed');
	boxHorarios.removeClass('opened');
}


function openBuscaForm()
{
	// console.log('open busca');
	
	closeMainMenu();
	closeHorariosBox();

	openBusca.addClass('opened');
	blocoBusca.addClass('opened');
}

function closeBuscaForm()
{	
	openBusca.removeClass('opened');
	blocoBusca.removeClass('opened');
	formBusca.find('span.error').removeClass('active');
	resetFormBusca.trigger('click');
}

function resetSearchError()
{
	formBusca.find('span.error').removeClass('active');
}

function search(value)
{
	if(value.length >= 3)
	{
		return true;
	}
	else
	{
		$(this).next('span.error').text('Mínimo de 3 caracteres').addClass('active');
	}	
}

function topBarScroll()
{
	if($(window).width() > 992)
	{
		$(window).scroll(function()
		{
			var pos = $(document).scrollTop();
			
			if (pos >= 34)
			{
				$("#mainHeader").addClass('scrolled');
			} else {
				$("#mainHeader").removeClass('scrolled');
			}
		});
	}
}

/* ------------------------------------------
TOP BAR
--------------------------------------------*/

var ControlesTopBar = function()
{
	/* SCROLL TOPBAR */

	// topBarScroll();

	/* ABRIR BUSCA TOPO */

	resetFormBusca.trigger('click');

	openBusca.on('click',function(e)
	{
		e.preventDefault();

		if($(this).hasClass('opened'))
			closeBuscaForm();
		else
			openBuscaForm();
	});
	/*

	closeBusca.on('click',function(e)
	{
		e.preventDefault();

		closeBuscaForm();
	});
	*/

	// formBusca.find('input#inputbusca').keyup(function(e)
	// {
	// 	if(e.keyCode == 13)
	//     {
	//     	e.preventDefault();
	//     	console.log('ENTER')
	// 		// search($(this).val());
	//     }
	// });

	// formBusca.find('button').click(function(e)
	// {
	// 	e.preventDefault();

	// 	console.log('BUTTON')
		
	// 	// search($(this).val());
	    
	// });

	formBusca.on('submit',function(e)
	{
		const value = $(this).find('input#inputbusca').val();
		const error = $(this).find('span.error')
		
		if(value.length >= 3)
			return true;
		else
		{
			error.text('Mínimo de 3 caracteres').addClass('active');

			setTimeout(() => 
			{
				error.removeClass('active');			
			}, "6000");;

			return false;
		}
	});

	formBuscaMobile.on('submit',function(e)
	{
		const value = $(this).find('input#inputbusca').val();
		const error = $(this).find('span.error')
		
		console.log('SUBMIT')

		if(value.length >= 3)
			return true;
		else
		{
			error.text('Mínimo de 3 caracteres').addClass('active');

			setTimeout(() => 
			{
				error.removeClass('active');			
			}, "6000");

			return false;
		}
	});

	/* ABRIR HORÁRIOS */

	openHorarios.on('click',function(e)
	{
		e.preventDefault();

		if($(this).hasClass('closed'))
		{
			openHorariosBox();
		}
		else
		{
			closeHorariosBox();
		}
	});

	/* MARCA ACTIVE LINK NO MENU */

	mainMenu.find('li.active-trail > a').each(function(index,value)
	{
		var obj = $(value);
		
		if(!$(value).hasClass('btMenu'))
		{
			var obj = $(value)
			var texto = obj.text();

			obj.html('<span>'+texto+'</span>');
		}
	});

	/* ABRIR MENU HOME */

// 	openMenu
// closeMenu

	openMenu.on('click',function(e) { openMainMenu(); });
	closeMenu.on('click',function(e) { closeMainMenu(); });

	$(document).click(function(event)
	{
		if($('#navegacaoPrincipal').hasClass('opened'))
		{ 
			$target = $(event.target);

		  	if(!$target.closest('.Menu #navegacaoPrincipal, .Menu .menuActions span.openMenu').length && $('.Menu #navegacaoPrincipal').is(":visible"))
		  	{
		    	closeMainMenu();
		  	}        
		}
	});

	// $('#menuMobileClose').on('click',function()
	// {
	// 	closeMainMenu();
	// });

	/* RESIZES */

	$(window).resize(function()
	{
		// topBarScroll();
	});
}
